<template>
  <div class="content">
    <v-header :activePage="'首页'"></v-header>

    <div class="main_quality_center" v-if="(isEmpty(plantIdSelected) === false) && (isEmpty(globalPlantList) === false)">
      <h3>{{ $parseLabel('QA外观DPPM') }}</h3>

      <div class="main_plant_select">
        <el-radio-group v-model="plantIdSelected" @input="handlePlantChange(plantIdSelected)">
          <el-radio-button 
            v-for="plantItem in globalPlantList" 
            :key="plantItem.plantId" 
            :label="plantItem.plantId">
            {{ $parseLabel(plantItem.plantName) }}
            </el-radio-button>
        </el-radio-group>
      </div>

      <appearance-dppm 
        :plantId="plantIdSelected"
        :chartId="'appearance_dppm'" 
        :chartData="appearanceDppmData" 
        :barTitle="$parseLabel('DPPM')"
        :lineTitle="$parseLabel('目标')"
        :width="'100%'" 
        :height="'400px'"/>
    </div>

    <v-footer></v-footer>
  </div>
</template>
        
<script>
import header from "@/components/header.vue";
import footer from "@/components/footer.vue";
import appearanceDppm from "@/views/index/components/appearanceDppm";
import moment from "moment";
import { getAppearanceDppmData } from "@/api/kpi"
export default {
  components: {
    "v-header": header,
    "v-footer": footer,
    appearanceDppm,
    moment
  },
  data() {
    return {
      selectMonthRange: [],
      selectMonthList: [],

      plantIdSelected: undefined,
      globalPlantList: [],

      appearanceDppmData: [],
    };
  },
  watch: {
    "$store.state.plantList": {
      handler() {
        this.reloadPlantList();
      },
    },
  },
  created() {
    this.reloadPlantList();

    //先改用最近一年的数据
    this.selectMonthRange = [
      moment().subtract(11, 'months').format('YYYY-MM'),
      moment().format('YYYY-MM')
    ];

    if(this.isEmpty(this.selectMonthRange) === false) {
      var diffMonths = Math.abs(moment(this.selectMonthRange[0]).diff(this.selectMonthRange[1], 'months'));
      this.selectMonthList = [];
      for(var index = 0; index < diffMonths; index++) {
        this.selectMonthList.push(moment(this.selectMonthRange[0]).add(index, 'months').format('YYYY-MM'));
      }

      this.doGetAppearanceDppmData();
    }
  },
  methods: {
    reloadPlantList() {
      this.plantIdSelected = undefined;

      var plantList = this.$store.state.plantList;
      if(this.isEmpty(plantList) === false) {
        this.globalPlantList = [];
        this.globalPlantList.push({
          plantId: 0,
          plantName: "全球"
        });

        plantList.forEach(hetPlantItem => {
          this.globalPlantList.push(hetPlantItem);
        });

        this.plantIdSelected = this.globalPlantList[0].plantId;
      }
    },
    handlePlantChange(sel){
      this.doGetAppearanceDppmData();
    },
    doGetAppearanceDppmData() {
      let _this = this;

      _this.appearanceDppmData = [];

      getAppearanceDppmData(_this.plantIdSelected, this.selectMonthRange).then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data.list) === false)) {
          if(_this.plantIdSelected === 0) {

            _this.appearanceDppmData = [];

            // 需要从各数据中去累加得出各月的数值并计算dppm
              _this.selectMonthList.forEach(monthItem => {
              //累计数值
              var testNumberSum = 0;
              var notGoodQtySum = 0;
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  if((_this.isEmpty(recordItem.testNumber) === false) && (_this.isEmpty(recordItem.numberOfBadAppearance) === false)) {
                    testNumberSum +=  parseInt(recordItem.testNumber);
                    notGoodQtySum +=  parseInt(recordItem.numberOfBadAppearance);
                  }
                }
              })

              if((testNumberSum != 0) && (notGoodQtySum != 0)) {
                _this.appearanceDppmData.push({
                  month: monthItem,
                  count: parseInt(notGoodQtySum * 1000000 / testNumberSum),
                  target: undefined
                })
              } else {
                _this.appearanceDppmData.push({
                  month: monthItem,
                  count: 0,
                  target: undefined
                })
              }
            });
          } else if(_this.plantIdSelected > 0) {

            _this.appearanceDppmData = [];

            // 直接取dppm
            _this.selectMonthList.forEach(monthItem => {
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  _this.appearanceDppmData.push({
                    month: recordItem.month,
                    count: recordItem.ppm,
                    target: recordItem.target
                  })
                }
              });
            });
          }
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.main_quality_center {
  min-width: 1500px;
  padding-bottom: 70px;
  background-color: #FFFFFF;

  h3 {
    height: 100px;
    line-height: 100px;
    font-size: 30px;
    text-align: center;
  }

  .main_plant_select {
    width: 85%;
    margin: auto;
    margin: auto;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;

    /deep/.el-radio-button__inner {
      font-size: 16px;
    }
  }
}
</style>